import { ReactElement } from 'react';
import { Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import ReportsSections from '../../ReportsSections';

import { DialogReportsCommonProps } from '../types';
import {
  DialogReportsContainer,
  DialogReportsHeader,
  DialogReportsHeaderCloseIcon,
  DialogReportsContent,
} from '../styles';

const DialogReportsVisits = ({
  open,
  onClose,
}: DialogReportsCommonProps): ReactElement => (
  <DialogReportsContainer
    open={open}
    PaperProps={{ sx: { maxWidth: 1200, minHeight: 504 } }}
  >
    <DialogReportsHeader>
      <Typography component="h2" variant="h6">
        Visitas
      </Typography>

      <DialogReportsHeaderCloseIcon
        aria-label="close"
        onClick={onClose}
        size="small"
      >
        <CloseIcon />
      </DialogReportsHeaderCloseIcon>
    </DialogReportsHeader>

    <DialogReportsContent dividers>
      <ReportsSections.Visits />
    </DialogReportsContent>
  </DialogReportsContainer>
);

export default DialogReportsVisits;
